exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".donation-received{margin-bottom:50px;font-family:Rubik-Medium;color:#4a4a4a}.donation-received,.name-donor{font-size:24px;line-height:32px}.name-donor{font-family:RobotoSlab-Bold;margin-top:30px;margin-bottom:0!important}p>b.amount-donation{color:#fd8205;font-family:Rubik-Bold}.rights-reserved{font-family:Rubik-Regular;font-size:16px;line-height:29px;color:#4a4a4a}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4d54d867","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/views/checkout/components/thankyou/PageThankYou.vue
// module id = 292
// module chunks = 0